// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1iNGH","head":"Table_head__2WfDK","col":"Table_col__2cRMI"};